/**
 * Privacy & Cookie policy texts in IT/EN/FR.
 * NOTE: P.IVA / Codice Fiscale del titolare devono essere inseriti dal cliente
 * (placeholder __PIVA__ / __CF__ — sostituire prima della pubblicazione).
 */

export const OWNER = {
  name: "B&B I Maestri",
  address: "Via dei Tribunali 257, 80139 Napoli, Italia",
  email: "bebimaestri@gmail.com",
  phone: "+39 339 5819593",
  piva: "02466610462",
  cf: "LMNVLR71T56F839W"
};

export const PRIVACY_POLICY = {
  it: {
    title: "Informativa sulla Privacy",
    updated: "Ultimo aggiornamento: 21 febbraio 2026",
    sections: [
      {
        h: "1. Titolare del trattamento",
        p: "Il Titolare del trattamento dei dati è B&B I Maestri (di seguito \"Titolare\"), con sede in Via dei Tribunali 257, 80139 Napoli (Italia). Email: bebimaestri@gmail.com · Telefono: +39 339 5819593."
      },
      {
        h: "2. Tipologie di dati raccolti",
        p: "Raccogliamo i dati personali che ci fornisci direttamente compilando il modulo di prenotazione o contattandoci via email/WhatsApp: nome e cognome, indirizzo email, numero di telefono, date di soggiorno, numero di ospiti, eventuali richieste speciali. Raccogliamo inoltre dati di navigazione anonimi (vedi Cookie Policy)."
      },
      {
        h: "3. Finalità del trattamento",
        p: "I tuoi dati vengono trattati esclusivamente per: (a) rispondere alle richieste di prenotazione e di informazioni; (b) gestire il soggiorno e la fatturazione; (c) adempiere ad obblighi di legge (es. comunicazione alloggiati alle autorità di pubblica sicurezza); (d) inviarti, solo previo tuo consenso esplicito, comunicazioni promozionali sulle nostre offerte."
      },
      {
        h: "4. Base giuridica",
        p: "Il trattamento si fonda sull'art. 6 del GDPR (Reg. UE 2016/679): esecuzione di un contratto precontrattuale o contrattuale di cui sei parte (richieste di prenotazione), adempimento di obblighi legali (es. registro alloggiati), tuo consenso esplicito (per le comunicazioni promozionali e per i cookie non tecnici)."
      },
      {
        h: "5. Modalità e tempi di conservazione",
        p: "I dati sono trattati con strumenti elettronici e organizzativi adeguati, in conformità alle misure di sicurezza previste dal GDPR. I dati relativi alle prenotazioni sono conservati per il tempo necessario alla gestione del soggiorno e per i successivi 10 anni in adempimento agli obblighi fiscali."
      },
      {
        h: "6. Destinatari dei dati",
        p: "I tuoi dati non vengono diffusi né venduti a terzi. Possono essere comunicati esclusivamente a soggetti che svolgono per noi attività strumentali (es. commercialista, fornitore di hosting/email) nominati Responsabili del trattamento e ad autorità di pubblica sicurezza quando previsto dalla legge."
      },
      {
        h: "7. I tuoi diritti",
        p: "Hai il diritto di accedere ai tuoi dati, rettificarli, chiederne la cancellazione (\"diritto all'oblio\"), limitare il trattamento, opporti al trattamento, ricevere i dati in formato portatile (artt. 15-22 GDPR). Per esercitare questi diritti scrivici a bebimaestri@gmail.com. Hai inoltre il diritto di proporre reclamo al Garante per la Protezione dei Dati Personali (www.garanteprivacy.it)."
      },
      {
        h: "8. Modifiche all'informativa",
        p: "Ci riserviamo di aggiornare questa informativa in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina con la data di aggiornamento."
      }
    ]
  },
  en: {
    title: "Privacy Policy",
    updated: "Last update: 21 February 2026",
    sections: [
      {
        h: "1. Data Controller",
        p: "The Data Controller is B&B I Maestri, with registered office at Via dei Tribunali 257, 80139 Naples (Italy). Email: bebimaestri@gmail.com · Phone: +39 339 5819593."
      },
      {
        h: "2. Types of data collected",
        p: "We collect personal data that you provide directly when filling in the booking form or contacting us via email/WhatsApp: full name, email address, phone number, stay dates, number of guests, special requests. We also collect anonymous browsing data (see Cookie Policy)."
      },
      {
        h: "3. Purpose of processing",
        p: "Your data are processed solely to: (a) reply to booking and information requests; (b) manage your stay and invoicing; (c) fulfil legal obligations (e.g. communication of guests to public security authorities); (d) send you, only with your explicit consent, promotional communications about our offers."
      },
      {
        h: "4. Legal basis",
        p: "Processing is based on art. 6 GDPR (Reg. EU 2016/679): performance of a pre-contractual or contractual agreement (booking requests), compliance with legal obligations (e.g. guest register), your explicit consent (for promotional communications and non-technical cookies)."
      },
      {
        h: "5. Storage method and duration",
        p: "Data are processed with adequate electronic and organisational tools, in compliance with GDPR security measures. Booking-related data are kept for the time necessary to manage the stay and for a further 10 years to comply with tax obligations."
      },
      {
        h: "6. Data recipients",
        p: "Your data are not disseminated or sold to third parties. They may only be communicated to entities performing instrumental activities for us (e.g. accountant, hosting/email provider), appointed as Data Processors, and to public security authorities when required by law."
      },
      {
        h: "7. Your rights",
        p: "You have the right to access your data, rectify them, request their deletion (\"right to be forgotten\"), restrict processing, object to processing, receive data in a portable format (art. 15-22 GDPR). To exercise these rights write to bebimaestri@gmail.com. You also have the right to lodge a complaint with the Italian Data Protection Authority (www.garanteprivacy.it)."
      },
      {
        h: "8. Changes to this policy",
        p: "We reserve the right to update this policy at any time. Changes will be published on this page with the updated date."
      }
    ]
  },
  fr: {
    title: "Politique de Confidentialité",
    updated: "Dernière mise à jour : 21 février 2026",
    sections: [
      {
        h: "1. Responsable du traitement",
        p: "Le Responsable du traitement des données est B&B I Maestri, ayant son siège Via dei Tribunali 257, 80139 Naples (Italie). Email : bebimaestri@gmail.com · Téléphone : +39 339 5819593."
      },
      {
        h: "2. Types de données collectées",
        p: "Nous collectons les données personnelles que vous fournissez directement en remplissant le formulaire de réservation ou en nous contactant par email/WhatsApp : nom et prénom, email, téléphone, dates de séjour, nombre d'invités, demandes spéciales. Nous collectons également des données de navigation anonymes (voir Politique Cookies)."
      },
      {
        h: "3. Finalités du traitement",
        p: "Vos données sont traitées exclusivement pour : (a) répondre aux demandes de réservation et d'informations ; (b) gérer votre séjour et la facturation ; (c) remplir les obligations légales (ex. communication des hôtes aux autorités de sécurité publique) ; (d) vous envoyer, uniquement avec votre consentement explicite, des communications promotionnelles sur nos offres."
      },
      {
        h: "4. Base juridique",
        p: "Le traitement se fonde sur l'art. 6 du RGPD (Règl. UE 2016/679) : exécution d'un contrat précontractuel ou contractuel (demandes de réservation), respect d'obligations légales (ex. registre des hôtes), votre consentement explicite (pour les communications promotionnelles et les cookies non techniques)."
      },
      {
        h: "5. Modalités et durée de conservation",
        p: "Les données sont traitées avec des outils électroniques et organisationnels adéquats, conformément aux mesures de sécurité du RGPD. Les données de réservation sont conservées pour la durée nécessaire à la gestion du séjour et pour les 10 années suivantes en application des obligations fiscales."
      },
      {
        h: "6. Destinataires des données",
        p: "Vos données ne sont ni diffusées ni vendues à des tiers. Elles ne peuvent être communiquées qu'à des sujets qui effectuent pour nous des activités instrumentales (ex. comptable, hébergeur/email), nommés Sous-traitants, et aux autorités de sécurité publique lorsque la loi l'exige."
      },
      {
        h: "7. Vos droits",
        p: "Vous avez le droit d'accéder à vos données, de les rectifier, d'en demander la suppression (« droit à l'oubli »), de limiter le traitement, de vous opposer au traitement, de recevoir les données dans un format portable (art. 15-22 RGPD). Pour exercer ces droits, écrivez à bebimaestri@gmail.com. Vous avez également le droit d'introduire une réclamation auprès de l'Autorité italienne de protection des données (www.garanteprivacy.it)."
      },
      {
        h: "8. Modifications de cette politique",
        p: "Nous nous réservons le droit de mettre à jour cette politique à tout moment. Les modifications seront publiées sur cette page avec la date de mise à jour."
      }
    ]
  }
};

export const COOKIE_POLICY = {
  it: {
    title: "Cookie Policy",
    updated: "Ultimo aggiornamento: 21 febbraio 2026",
    sections: [
      {
        h: "Cosa sono i cookie",
        p: "I cookie sono piccoli file di testo memorizzati dal browser durante la navigazione. Servono per far funzionare il sito, ricordare le tue preferenze e — solo previo consenso — misurare in forma aggregata l'utilizzo del sito."
      },
      {
        h: "Cookie tecnici (sempre attivi)",
        p: "Utilizziamo cookie tecnici e di funzionalità strettamente necessari per il funzionamento del sito (es. memorizzare la lingua scelta, lo stato del consenso cookie). Per questi cookie non è richiesto il tuo consenso (art. 122 Codice Privacy)."
      },
      {
        h: "Cookie analitici e di terze parti",
        p: "Su tuo esplicito consenso ('Accetta tutti'), utilizziamo Google Analytics 4 (provider: Google Ireland Ltd) per misurare in forma anonima e aggregata le visite al sito: pagine visitate, tempo di permanenza, dispositivi utilizzati. L'indirizzo IP viene anonimizzato. Non utilizziamo cookie di profilazione né di marketing. Puoi revocare il consenso in qualsiasi momento tramite il link 'Preferenze cookie' in fondo a questa pagina."
      },
      {
        h: "Come gestire i cookie",
        p: "Puoi accettare, rifiutare o modificare in ogni momento la tua scelta cliccando il link \"Preferenze cookie\" in fondo a questa pagina. Puoi inoltre disabilitare i cookie direttamente dalle impostazioni del tuo browser (Chrome, Safari, Firefox, Edge): consulta la documentazione del browser per le istruzioni specifiche."
      }
    ]
  },
  en: {
    title: "Cookie Policy",
    updated: "Last update: 21 February 2026",
    sections: [
      {
        h: "What cookies are",
        p: "Cookies are small text files stored by the browser during navigation. They help the site work, remember your preferences and — only with your consent — measure site usage in aggregate form."
      },
      {
        h: "Technical cookies (always on)",
        p: "We use technical and functional cookies strictly necessary for the site to function (e.g. storing your chosen language, the state of your cookie consent). No consent is required for these (art. 122 Italian Privacy Code)."
      },
      {
        h: "Analytics & third-party cookies",
        p: "Upon your explicit consent ('Accept all'), we use Google Analytics 4 (provider: Google Ireland Ltd) to measure visits to the site in anonymous, aggregated form: pages visited, time spent, devices used. IP addresses are anonymised. We do not use profiling or marketing cookies. You can withdraw consent at any time via the 'Cookie preferences' link at the bottom of this page."
      },
      {
        h: "How to manage cookies",
        p: "You can accept, reject or change your choice at any time by clicking the \"Cookie preferences\" link at the bottom of this page. You can also disable cookies directly from your browser settings (Chrome, Safari, Firefox, Edge): see the browser documentation for specific instructions."
      }
    ]
  },
  fr: {
    title: "Politique Cookies",
    updated: "Dernière mise à jour : 21 février 2026",
    sections: [
      {
        h: "Que sont les cookies",
        p: "Les cookies sont de petits fichiers texte stockés par le navigateur pendant la navigation. Ils aident le site à fonctionner, à mémoriser vos préférences et — uniquement avec votre consentement — à mesurer l'utilisation du site sous forme agrégée."
      },
      {
        h: "Cookies techniques (toujours actifs)",
        p: "Nous utilisons des cookies techniques et fonctionnels strictement nécessaires au fonctionnement du site (par ex. mémorisation de la langue choisie, état du consentement cookies). Aucun consentement n'est requis pour ces cookies (art. 122 du Code de la Vie Privée italien)."
      },
      {
        h: "Cookies analytiques et de tiers",
        p: "Sur votre consentement explicite (« Tout accepter »), nous utilisons Google Analytics 4 (fournisseur : Google Ireland Ltd) pour mesurer les visites du site de manière anonyme et agrégée : pages visitées, temps passé, appareils utilisés. L'adresse IP est anonymisée. Nous n'utilisons pas de cookies de profilage ou de marketing. Vous pouvez retirer votre consentement à tout moment via le lien « Préférences cookies » en bas de cette page."
      },
      {
        h: "Comment gérer les cookies",
        p: "Vous pouvez accepter, refuser ou modifier votre choix à tout moment en cliquant sur le lien « Préférences cookies » en bas de cette page. Vous pouvez également désactiver les cookies directement depuis les paramètres de votre navigateur (Chrome, Safari, Firefox, Edge) : consultez la documentation du navigateur pour des instructions spécifiques."
      }
    ]
  }
};
